import { FormHelp } from '@zillow/constellation-10';

export type UnitRow = {
  id: string;
  unitNumber: string;
  beds: string;
  baths: string;
  size: string;
};

export const MAX_UNIT_NUMBER_LENGTH = 20;

export const createEmptyRow = (): UnitRow => ({
  id: crypto.randomUUID(),
  unitNumber: '',
  beds: '',
  baths: '',
  size: '',
});

export const isDuplicateUnitNumber = (
  id: string,
  unitNumber: string,
  rows: Array<UnitRow>,
  existingUnitNumbers: Array<string>,
): boolean => {
  const trimmed = unitNumber.trim();
  if (!trimmed) return false;
  return (
    rows.some((row) => row.id !== id && row.unitNumber.trim() === trimmed) || existingUnitNumbers.includes(trimmed)
  );
};

export const DescriptionPlaceholder = () => (
  <FormHelp aria-hidden="true" css={{ visibility: 'hidden' }}>
    placeholder
  </FormHelp>
);
